import React, { useEffect, useState } from 'react'
import { Button, message, Modal, PageHeader } from 'antd'
import ActTable from '../ActTable'
import ChooseProjectModal from '../../project/ChooseProjectModal'
import ActModal from '../ActModal'
import usePagination from '../../hooks/usePagination'
import { getActs, deleteAct } from '../../../services/acts'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const { confirm } = Modal

const ActView = () => {
  const [isLoading, setIsLoading] = useState(false)

  const [filter, setFilter] = useState({})
  const [pageTotal, setPageTotal] = useState(0)
  const [tablePagination, page, pageSize, setPage] = usePagination(pageTotal)

  const [showProjectDialog, setShowProjectDialog] = useState(false)
  const [showActDialog, setShowActDialog] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)

  const [acts, setActs] = useState([])
  const [selectedAct, setSelectedAct] = useState(null)

  const requestActs = () => {
    const pagination = { page, pageSize }
    setIsLoading(true)
    getActs(filter, pagination)
      .then(({ data }) => {
        setActs(data?.results)
        setPageTotal(data?.pagination.total)
      })
      .catch((error) => {
        message.error('Ошибка загрузки актов')
      })
      .finally(() => setIsLoading(false))
  }

  const deleteAction = (id) => {
    setIsLoading(true)
    deleteAct(id)
      .then(() => requestActs())
      .catch(() => {
        message.error('Ошибка удаления акта')
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => requestActs(), [filter, page, pageSize])

  const onProjectDialogCancel = () => setShowProjectDialog(false)

  const onProjectSubmit = (project) => {
    setSelectedProject(project)
    setShowProjectDialog(false)
    setShowActDialog(true)
  }

  const onEditAction = (record) => {
    setSelectedAct(record)
    setShowActDialog(true)
  }

  const onDeleteAction = (record) => {
    confirm({
      title: `Удалить акт № ${record.number}`,
      icon: <ExclamationCircleOutlined />,
      okText: 'Да',
      okType: 'danger',
      cancelText: 'Нет',
      onOk: () => deleteAction(record.id),
      onCancel: () => {
        // nothing
      },
    })
  }

  const onFilterFormSubmit = (values) => setFilter({ projects: values?.projects || [] })

  const onFilterFormClear = () => setFilter({})

  return (
    <div>
      <PageHeader
        ghost={false}
        title="Акты"
        extra={[
          <Button key="1" type="primary" onClick={() => setShowProjectDialog(true)}>
            Создать новый акт
          </Button>,
        ]}
      />
      <ActTable
        acts={acts}
        isLoading={isLoading}
        tablePagination={tablePagination}
        onEditAction={onEditAction}
        onDeleteAction={onDeleteAction}
        onFilterFormSubmit={onFilterFormSubmit}
        onFilterFormClear={onFilterFormClear}
      />
      <ChooseProjectModal showModal={showProjectDialog} onFinish={onProjectSubmit} onChancel={onProjectDialogCancel} />
      <ActModal
        showModal={showActDialog}
        project={selectedProject}
        act={selectedAct}
        onClose={() => {
          setShowActDialog(false)
          setSelectedAct(null)
          requestActs()
        }}
        onSuccess={() => {
          setShowActDialog(false)
          requestActs()
        }}
      />
    </div>
  )
}

export default ActView
